export const toFileSize = (fileSize: number) => {
  const formattedSize =
    fileSize >= 1048576 // 1 MB in bytes
      ? `${(fileSize / 1048576).toFixed(2)} MB`
      : `${(fileSize / 1024).toFixed(2)} KB`

  return formattedSize
}

const NumberIdr = new Intl.NumberFormat('id-ID', {
  style: 'currency',
  currency: 'IDR',
})

const NumberIdrFormat = new Intl.NumberFormat('id-ID', {
  style: 'decimal',
  minimumFractionDigits: 0,
})

export function toIdr(num: number) {
  return NumberIdr.format(num)
}

export function toIdrWithoutRp(num: number) {
  return NumberIdrFormat.format(num)
}
